import { React, useEffect } from 'react';
import Nav from './Nav2';
import logo from './img/gap.png';
import SearchDoc from './search';

function Student_srch() {
  return (
    <div className='xp'>
        <div className="student_srch">
            <Nav/>
            <div className='choose-box'>
                <div style={{textAlign: "center"}}>
                    <img src={logo} alt="GAP Logo" width={250} style={{marginBottom: -35}}/>
                </div>
                <SearchDoc/>
            </div>
        </div>
        <br/>
        <br/>
        {/* <footer id='footer'> <br/> G.A.P 2024 © All Rights Reserved. <br/> <br/> </footer> */}
        <div>
        </div>
    </div>
  );
}

export default Student_srch;
